import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    uid: null,
    quickStatus: false,
    userPic: "",
    companyId: "",
    asideCon: false,
    loadingShow: true,
    loadingAmin: true,
  },
  mutations: {
    setUid(state, uid) {
      state.uid = uid;
    },
    quitPage(state) {
      state.quickStatus = true;
    },
    cancelQuitPage(state) {
      state.quickStatus = false;
    },
    changeUserPic(state, url) {
      state.userPic = url;
    },
    changeCompanyId(state, id) {
      state.companyId = id;
    },
    changeAside(state, val) {
      state.asideCon = val;
    },
    ChangeLoadingShow(state, val) {
      state.loadingShow = val;
    },
    ChangeLoadingAmin(state, val) {
      state.loadingAmin = val;
    },
  },
  getters: {
    getUid: (state) => state.uid,
  },
  actions: {},
  modules: {},
});
